export function swapElem<T>(i1: number, i2: number, array_: T[]): T[] {
  const array = [...array_];

  const e1 = array[i1];

  array[i1] = array[i2];
  array[i2] = e1;

  return array;
}

/**
 * Reduces an array of options into a configuration object.
 *
 * @param {object} acc - configuration object.
 * @param {string} option - option name.
 * @return {*} - A configuration object.
 */
export function configReducer(
  acc: Record<string, boolean>,
  option: string,
): Record<string, boolean> {
  acc[option] = true;

  return acc;
}

type CSVStringToArrayOptions = {
  sort?: boolean;
};

export function csvStringToArray(
  options: CSVStringToArrayOptions,
  value?: string | null,
): string[] {
  const { sort = false } = options;
  if (!value) {
    return [];
  }

  const values = value.split(",");
  if (sort) {
    values.sort();
  }

  return values;
}
